import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { TextField } from "@src/components/ui-kit/TextField";
import { fieldToInputProps } from "@src/utils/forms/inputHelpers";
import { observer } from "mobx-react-lite";
import type { GlobalCreditAccountModalStore } from "./store";

type Props = {
  store: GlobalCreditAccountModalStore;
  isLoading: boolean;
};

export const GlobalCreditAccountModal = observer(
  function GlobalCreditAccountModal({ store, isLoading }: Props) {
    if (!store.form) {
      return null;
    }

    return (
      <Modal
        isCentered
        isOpen={store.modalState.isOpen}
        onClose={() => {
          if (isLoading) return;
          store.modalState.onClose();
        }}
        size="md"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {store.isEditMode ? (
              <Trans>Edit expense credit account</Trans>
            ) : (
              <Trans>Create expense credit account</Trans>
            )}
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <VStack align="stretch" spacing="4">
              <TextField
                label={t`Title`}
                {...fieldToInputProps(store.form.$.title)}
              />

              <FormControl>
                <FormLabel>
                  <Trans>Note</Trans>
                </FormLabel>
                <Textarea
                  onChange={({ target }) =>
                    store.form?.$.note.onChange(target.value)
                  }
                  value={store.form.$.note.value}
                />
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button
              mr="3"
              isLoading={isLoading}
              onClick={store.modalState.onClose}
              variant="ghost"
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button isLoading={isLoading} onClick={store.handleSubmit}>
              {store.isEditMode ? <Trans>Update</Trans> : <Trans>Create</Trans>}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  },
);
